<template>
    <b-modal ref="contactDeleteDialog" title-tag="h2" :title="title" lazy>
        <h5 v-if="details">
            {{ details.name || details.firstname + " " + details.lastname }}
        </h5>

        Are you sure you want to permanently delete this relationship?

        <template v-slot:modal-footer="{ cancel, close }">
            <modal-footer
                :is-loading="isLoading"
                ok-title="Proceed"
                @ok-action="remove(cancel)"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import Relationships from "@/services/contact-relationships";

const ACTOR_COLLEAGUE = "5";
const BUSINESS_AFFILIATE = "1";

export default {
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer")
    },
    data() {
        return {
            isLoading: false,
            details: null,
            title: "Delete Relationship"
        };
    },
    computed: {
        contact() {
            return this.$store.getters["contact/contactDetails"];
        },
        isCompany() {
            return this.$store.getters["contact/isCompany"];
        }
    },
    methods: {
        open(details) {
            this.details = details;
            this.$refs["contactDeleteDialog"].show();
        },
        getRelationType() {
            let rType = this.details.relation_id + ":";
            let relationId = this.details.relation_id.toString();
            let entityType = this.details.entity_type;

            if (this.isCompany) {
                if (entityType === "actor") {
                    if (this.details.relation_flag === 1) {
                        return rType + "0";
                    } else {
                        return rType + "1";
                    }
                } else if (entityType === "business") {
                    if (
                        relationId === ACTOR_COLLEAGUE ||
                        relationId === BUSINESS_AFFILIATE
                    ) {
                        return rType + "0";
                    } else {
                        return rType + this.details.relation_flag;
                    }
                } else {
                    return relationId;
                }
            } else {
                if (entityType === "actor") {
                    if (
                        relationId === ACTOR_COLLEAGUE ||
                        relationId === BUSINESS_AFFILIATE
                    ) {
                        return rType + "0";
                    } else {
                        return rType + this.details.relation_flag;
                    }
                } else if (entityType === "business") {
                    if (
                        relationId === ACTOR_COLLEAGUE ||
                        relationId === BUSINESS_AFFILIATE
                    ) {
                        return rType + "1";
                    } else {
                        return rType + this.details.relation_flag;
                    }
                } else {
                    return relationId;
                }
            }
        },
        remove(closeFn) {
            this.isLoading = true;
            let params = {
                rtype: this.getRelationType(),
                entity_id: this.details.id,
                entity_type: this.details.entity_type
            };
            if (!this.isCompany) {
                Relationships.deleteContactRelationship(this.contact.id, params)
                    .then(() => {
                        closeFn();
                        this.isLoading = false;
                        this._message("Relationship successfully deleted");
                        this.$emit("succeed");
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this._message(
                            "Error : Unable to delete company",
                            "danger"
                        );
                        console.error(error);
                    });
            } else {
                Relationships.deleteCompanyRelationship(this.contact.id, params)
                    .then(() => {
                        closeFn();
                        this.isLoading = false;
                        this._message("Relationship successfully deleted");
                        this.$emit("succeed");
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this._message(
                            "Error : Unable to delete company",
                            "danger"
                        );
                        console.error(error);
                    });
            }
        }
    }
};
</script>
